import React, { useState } from 'react';
import styles from '../styles/wizards/AddTimesheetWizard.scss';
import * as _ from 'lodash';
import AddTimesheetForm from '../forms/add_timesheet_wizard/AddTimesheetForm';
import { withRouter } from 'react-router';
import {
  __,
  getActiveProject,
  getActiveStage,
  validateForm,
  convertHoursAndMinutesToMinutes,
} from '../core/utils';
import Localization from '../helpers/Localization';
import { subscribe } from 'react-contextual';
import { connect } from 'react-redux';
import AddTimesheetIcon from '../assets/images/add-time-icon.svg';
import {
  createTimeOff,
  createTimesheet,
  listTimesheets,
} from '../redux/actions/table/timesheets';
import { setNotification } from '../redux/actions/general/notification';
import { readTask } from '../redux/actions/table/all_tasks';
import classNames from 'classnames';
import AddTimeOffForm from '../forms/add_timesheet_wizard/AddTimeOffForm';
import moment from 'moment';

const AddTimesheetWizard = function (props) {
  const steps = [
    {
      id: '01',
      title: __('wizard.timesheet.title.time-entry'),
    },
    {
      id: '02',
      title: __('wizard.timesheet.title.time-off-entry'),
    },
  ];

  const [active, set_active_step] = useState(_.first(steps));

  const _setActiveStep = (id) => {
    set_active_step(_.find(steps, (item) => item.id === id));
  };

  const _handleAddTimeEntrySubmit = (formData) => {
    const { auth } = props;
    formData = {
      ...formData,
      user_id: _.includes(auth?.permissions, 'create.any.timesheet.entry')
        ? formData?.user_id
        : props?.auth?.id,
      minutes: convertHoursAndMinutesToMinutes(
        formData?.hours,
        formData?.minutes
      ),
    };

    return validateForm(
      createTimesheet(formData).then(({ response }) => {
        const task_id = props.task_id;

        task_id ? readTask(task_id) : listTimesheets();

        setNotification(__('wizard.add-timesheet.confirm'));
        props.onClose();
      })

      // ).catch(({ errors }) => {
      //   if (_.has(errors, 'minutes')) {
      //     return setFormErrors('add_timesheet_wizard.add_timesheet', {
      //       hours: ['Hours is required.'],
      //       ...errors,
      //     });
      //   }

      //   return setFormErrors('add_timesheet_wizard.add_timesheet', errors);
      // });
    );
  };

  const _handleAddTimeOffSubmit = (formData) => {
    const { auth } = props;
    let { newFormData, date } = formData;

    newFormData = {
      ...newFormData,
      user_id: _.includes(auth?.permissions, 'create.any.leave.request')
        ? formData?.user_id
        : auth?.id,
      reason: formData?.reason || '',
      description: formData?.description || '',
      approvers: _.map(formData.approvers, 'id'),
      followers: _.map(formData.followers, 'id'),
      all_day: formData?.all_day ? formData?.all_day : 0,
      ...(formData.all_day
        ? { start_time: formData?.date?.start, end_time: formData?.date?.end }
        : {
            date: formData.date,
            minutes: convertHoursAndMinutesToMinutes(
              formData?.hours,
              formData?.minutes
            ),
          }),
    };

    return validateForm(
      createTimeOff(newFormData)
        .then(({ response }) => {
          listTimesheets();
          setNotification(__('wizard.add-timesheet.confirm'));
          props.onClose();
        })
        .catch(({ status, response: { error } }) => {
          if (status === 412)
            return setNotification({
              text: error,
              type: 'warning',
            });
        })
    );
  };

  const active_project = getActiveProject();
  const active_stage = getActiveStage();

  return (
    <>
      <div
        className={classNames(styles.header, {
          [styles.extraPadding]: props?.task_id,
        })}
      >
        <div className={styles.title}>
          <div className={styles.left}>
            <span>{__('wizard.add-timesheet.title.create-new')}</span>
            <span>{__('wizard.add-timesheet.subtitle.create-new')}</span>
          </div>
          <div className={styles.right}>
            <AddTimesheetIcon />
          </div>
        </div>

        {!props.task_id && (
          <div className={styles.steps}>
            {_.map(steps, (step, i) => (
              <div
                key={i}
                onClick={() => _setActiveStep(step.id)}
                className={classNames(
                  styles.step,
                  active.id == step.id && styles.active
                )}
              >
                <span>{step.id}</span>
                <span>{step.title}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={styles.body}>
        {active.id === '01' && (
          <AddTimesheetForm
            onSubmit={_handleAddTimeEntrySubmit}
            initialValues={{
              project_id: active_project,
              stage_id: active_stage,
              is_makeup_time: 0,
              user_id: props.auth.id,
              task_id: props.task_id,
              date: moment(new Date()).local().format('YYYY-MM-DD'),
              hours: 8,
            }}
          />
        )}

        {active.id === '02' && (
          <AddTimeOffForm
            onSubmit={_handleAddTimeOffSubmit}
            initialValues={{ user_id: props.auth.id }}
          />
        )}
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    table: state.table['timesheets'],
    auth: state.auth,
    task_id: state.table['timesheets'].task_id,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(subscribe(Localization, 'localization')(AddTimesheetWizard))
);
